import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { MessageClaraDraftClaim } from '@/modules/messenger/_modules/message/models/MessageClaraDraftClaim';
import { MessageClaraDraftSource } from '@/modules/messenger/_modules/message/models/MessageClaraDraftSource';

export class MessageClaraDraft extends BaseEntityModel {
  id?: number;
  messageId?: number;
  claims: MessageClaraDraftClaim[];
  sources: MessageClaraDraftSource[];
  evidenceSummary?: string | null;

  constructor(model: Partial<MessageClaraDraft> = {}) {
    super(model);

    this.id = model.id;
    this.messageId = model.messageId;
    this.claims = MessageClaraDraftClaim.mapModels(model.claims);
    this.sources = MessageClaraDraftSource.mapModels(model.sources);
    this.evidenceSummary = model.evidenceSummary;
  }
}
